export default [
	{
		path: "/test",
		component: () => import("@/view/test/Index"),
		meta: { layout: "WideLayout" }
    },
	{
		path: "/test/menu-reload",
		component: () => import("@/view/test/MenuReload"),
		meta: { layout: "WideLayout" }
	},
	{
		path: "/test/pagination",
		component: () => import("@/view/test/Pagination"),
		meta: { layout: "WideLayout" }
	},
	{
		path: "/test/save-dtm-file-as-dtms",
		component: () => import("@/view/test/SaveDtmFileAsDtms"),
		meta: { layout: "WideLayout" }
	},
	{
		path: "/test/save-dtms-file-as-dtm",
		component: () => import("@/view/test/SaveDtmsFileAsDtm"),
		meta: { layout: "WideLayout" }
	},
	{
		path: "/test/canvas-template",
		component: () => import("@/view/test/CanvasTemplate"),
		meta: { layout: "WideLayout" }
	},
	{
		path: "/test/openapi",
		component: () => import("@/view/test/OpenAISample.vue"),
		meta: { layout: "WideLayout" }
	},
	{
		path: "/test/braille",
		component: () => import("@/view/test/Braille.vue"),
		meta: { layout: "WideLayout" }
	},
	{
		path: "/test/session",
		component: () => import("@/view/test/Session.vue"),
		meta: { layout: "WideLayout" }
	},
	{
		path: "/test/websocket",
		component: () => import("@/view/test/WebSocket"),
		meta: { layout: "WideLayout" }
	},
	{
		path: "/test/middleware",
		component: () => import("@/view/test/Middleware"),
		meta: { layout: "WideLayout" }
	},
	{
		path: "/test/pdf-convert-demo",
		component: () => import("@/view/test/PdfConvertDemo.vue"),
		meta: { layout: "WideLayout" }
	},
];
